import React from 'react';

const Header = () => (
  <div className="post--type post--journey d-flex align-items-center justify-content-between">
    <div>
      <h1>{lang.PAGE_TITLE}</h1>
      <p>{lang.PAGE_DESC}</p>
    </div>

    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M46.9074 0.687499C46.5399 0.459999 46.0799 0.439999 45.6924 0.632499L31.2524 7.8525L16.8124 0.632499C16.4599 0.457499 16.0474 0.457499 15.6949 0.632499L0.694883 8.1325C0.272383 8.345 0.00488281 8.7775 0.00488281 9.25V46.75C0.00488281 47.1825 0.229883 47.585 0.597383 47.8125C0.797383 47.9375 1.02488 48 1.25488 48C1.44488 48 1.63738 47.955 1.81488 47.8675L16.2549 40.6475L30.6949 47.8675C31.0474 48.0425 31.4624 48.0425 31.8124 47.8675L46.8124 40.3675C47.2349 40.155 47.5024 39.7225 47.5024 39.25V1.75C47.5024 1.3175 47.2774 0.914999 46.9099 0.687499H46.9074ZM14.9999 38.4775L2.49988 44.7275V10.0225L14.9999 3.7725V38.4775ZM17.4999 3.7725L29.9999 10.0225V44.7275L17.4999 38.4775V3.7725ZM44.9999 38.4775L32.4999 44.7275V10.0225L44.9999 3.7725V38.4775Z" fill="black"/>
    </svg>
  </div>
);

export default Header;
